import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import './index.style.less';
import AppList from '@crema/core/AppList';
import ListEmptyResult from '@crema/core/AppList/ListEmptyResult';
import ListItem from './ListItem';
import {MediaContext} from '../../MediaContext';

const MediaList = () => {
  const intl = useIntl();
  const mediaContext = useContext(MediaContext);
  const {mediaList, loading} = mediaContext;

  return (
    <AppList
      delay={200}
      type='alpha'
      data={mediaList}
      renderItem={(media) => <ListItem item={media} key={media.id} />}
      ListEmptyComponent={
        <ListEmptyResult
          content={intl.messages['common.noRecordFound']}
          loading={loading}
        />
      }
    />
  );
};

export default MediaList;
